import { render, staticRenderFns } from "./ResearchCategory.vue?vue&type=template&id=a45af914&scoped=true&"
import script from "./ResearchCategory.vue?vue&type=script&lang=js&"
export * from "./ResearchCategory.vue?vue&type=script&lang=js&"
import style0 from "./ResearchCategory.vue?vue&type=style&index=0&id=a45af914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45af914",
  null
  
)

export default component.exports